import React from 'react';

import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

interface QpsAnswerFeedbackProps {
  isCorrect: boolean;
}

const QpsAnswerFeedback: React.FC<QpsAnswerFeedbackProps> = ({ isCorrect }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.feedback} ${isCorrect ? styles.correct : styles.incorrect}`}>
      <span aria-hidden="true">
        <MtxIcon name={isCorrect ? 'check-circle' : 'cross-circle'} size={32} />
      </span>
      <div>
        <p className={styles.title}>{t(isCorrect ? 'qps.feedback.correctTitle' : 'qps.feedback.incorrectTitle')}</p>
        <p className={styles.message}>
          {t(isCorrect ? 'qps.feedback.correctMessage' : 'qps.feedback.incorrectMessage')}
        </p>
      </div>
    </div>
  );
};

export default QpsAnswerFeedback;
